import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bloqueos',
  templateUrl: './bloqueos.component.html',
  styleUrls: ['./bloqueos.component.css']
})
export class BloqueosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/bloqueos/bloqueos.component.ts